import styles from "./PersonalData.module.scss";

const PersonalData: React.FC = () => {
  return <div className={styles.body}>Personal Data</div>;
};

export default PersonalData;
